import React from "react";
import { Container } from "react-bootstrap";
import "./Fourth.css";
import frame from "../../../../Asset/d2c/Frame.svg";
import frame1 from "../../../../Asset/d2c/Frame-1.svg";
import frame2 from "../../../../Asset/d2c/Frame-2.svg";

const Fourth = () => {
  return (
    <>
      <section className="fourth-d2c-section">
        <Container>
          <div className="core-pillers-box">
            <h3 className="title-text">
              Master the <b> 3 Core Pillars </b> of Your D2C Business with{" "}
              <b> Codeffi</b>
            </h3>
            <div className="row card-container-box">
              <div className="col-md-12 col-lg-4 card-box">
                <div className="card-img-section">
                  <img src={frame} alt="card" className="w-100" />
                </div>
                <div className="content-box">
                  <h4 className="content-title">Customer Experience</h4>
                  <ul className="content-list">
                    <li className="content-item">
                      Stunning, user-centric website / Mobile app
                    </li>
                    <li className="content-item">Expert UI/UX design </li>
                    <li className="content-item">Seamless navigation</li>
                    <li className="content-item">
                      Engaging interactions with customers
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12 col-lg-4 card-box">
                <div className="card-img-section">
                  <img src={frame1} alt="card" className="w-100" />
                </div>
                <div className="content-box">
                  <h4 className="content-title">Customer Retention</h4>
                  <ul className="content-list">
                    <li className="content-item">Loyalty & Rewards Programs</li>
                    <li className="content-item">Increased Brand Engagement</li>
                    <li className="content-item">Encourage repeat purchases</li>
                    <li className="content-item">Competitive edge</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-12 col-lg-4 card-box">
                <div className="card-img-section">
                  <img src={frame2} alt="card" className="w-100" />
                </div>
                <div className="content-box">
                  <h4 className="content-title">Monetization</h4>
                  <ul className="content-list">
                    <li className="content-item">Optimize Sales Funnel</li>
                    <li className="content-item">Data-driven strategies</li>
                    <li className="content-item">Upselling & cross-selling</li>
                    <li className="content-item">
                      Increase conversion rates and revenue
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Fourth;
